import { useState, useEffect, useRef, useImperativeHandle ,forwardRef} from "react";
import "./ProjectFilter.scss";

// import Comp_GeneralFeatures from "../datacontrols/controlGeneral";
import Comp_Colonies from "../datacontrols/controlColony";
import Comp_ProjectDeveloper from "../datacontrols/controlProjectDeveloper";
// import Comp_TransactionType from "../datacontrols/controlTransactiontype";
// import Comp_PropertyType from "../datacontrols/controlPropertytype";

import search from "../../assets/search.png";
import ToggleSelect from "../toggleselect/ToggleSelect";

const ProjectFilter = forwardRef (({ filterOptions = {}, onFilterApply },ref) =>{
  // Local state mirrors props for UI editing
  const [query, setQuery] = useState(filterOptions);

  // Refs for tag components
  const tagrefColony = useRef(null);
  const tagrefDeveloper = useRef(null);
//   const tagrefPropertyType = useRef(null);
//   const tagrefTransactionType = useRef(null);
//   const tagrefGeneral = useRef(null);

  const [selectedColonies, setSelectedColonies] = useState([]);
  const [selectedDevelopers, setSelectedDevelopers] = useState([]);
//   const [selectedTransType,setselectedTranstype]=useState([])
//   const [selectedPropertyType,setselectedPropertyType]=useState([])
//   const [selectedGeneralTags,setselectedGeneralTags]=useState([])





useEffect(() => {
  if (!filterOptions) return;

  setQuery({ ...filterOptions });


  if (!tagrefColony.current) return;

  setSelectedColonies(
    filterOptions.colonies?.length
      ? tagrefColony.current.getObjectFromIds(filterOptions.colonies)
      : []
  );

  setSelectedDevelopers(
    filterOptions.developers?.length
      ? tagrefDeveloper.current.getObjectFromIds(filterOptions.developers)
      : []
  );



}, [filterOptions]);



// Expose functions via ref
  useImperativeHandle(ref, () => ({
    showFilter: (newFilters) => {
      if (!newFilters) return;
      setQuery({ ...newFilters });

      // Update tag components
      if (tagrefColony.current) {
        setSelectedColonies(
          newFilters.colonies?.length
            ? tagrefColony.current.getObjectFromIds(newFilters.colonies)
            : []
        );
      }
      if (tagrefDeveloper.current) {
        setSelectedDevelopers(
          newFilters.developers?.length
            ? tagrefDeveloper.current.getObjectFromIds(newFilters.developers)
            : []
        );
      }

    },
  }));



// Tag change handlers
  const handleColonyChange = (newTags) => {
    setSelectedColonies(newTags);
    const filteredTags = newTags.filter(tag => tag != null && tag.status !== "delete");    
    // ✅ Prepare colonies array with only valid IDs
    const colonyIds = filteredTags
        .filter(tag => tag && tag.id != null) // remove any tag without an id
        .map(tag => tag.id);
    
      // ✅ Update query with valid colony IDs
      const updatedQuery = {
        ...query, // keep existing fields
        colonies: colonyIds,
      };
    setQuery(updatedQuery);
    // if (onFilterApply) onFilterApply(newQuery); // 
  };


  const handleDeveloperChange = (newTags) => {
    setSelectedDevelopers(newTags);
    const filteredTags = newTags.filter(tag => tag != null && tag.status !== "delete");    
    // ✅ Prepare developers array with only valid IDs
    const developerIds = filteredTags
        .filter(tag => tag && tag.id != null) // remove any tag without an id
        .map(tag => tag.id);
    
      // ✅ Update query with valid developer IDs
      const updatedQuery = {
        ...query, // keep existing fields
        developers: developerIds,
      };
    setQuery(updatedQuery);
    // if (onFilterApply) onFilterApply(newQuery); // 
  };





  // Basic input change handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setQuery(prev => ({ ...prev, [name]: value }));
  };



const handleFilter = (e) => {
  e.preventDefault();
  // console.log("selectedColonies",selectedColonies)

  // Build the final filter object from the current selected states
const finalQuery = {
  ...(selectedColonies?.filter(c => c.status !== "delete").length > 0 && {
    colonies: selectedColonies
      .filter(c => c.status !== "delete")
      .map(c => c.id)
  }),

  ...(selectedDevelopers?.filter(d => d.status !== "delete").length > 0 && {
    clientids: selectedDevelopers
      .filter(d => d.status !== "delete")
      .map(d => d.id)
  }),

  ...(query.project && { projectname: query.project }),
  ...(query.bedroom && { beds: query.bedroom }),
  ...(query.minprice && { budgetfrom: query.minprice }),
  ...(query.maxprice && { budgetto: query.maxprice }),
  ...(query.minarea && { areafrom: query.minarea }),
  ...(query.maxarea && { areato: query.maxarea }),
  ...(query.type && { residential: query.type })
};

  console.log("Filter Apply clicked. Final Query:", finalQuery);

  if (onFilterApply) onFilterApply(finalQuery);
};



  return (
    <div className="projectfilter">
  
      <div className="row first">
        <div className="item">
          <label>Location</label>

          <Comp_Colonies
            ref={tagrefColony}
            defaultTags={selectedColonies}
            selectedTags={selectedColonies}
            setSelectedTags={(tags) =>
                handleColonyChange(tags)}
          />
        </div>
      </div>
 
      <div className="row second">
        <div className="item dropdown">
          <label>Developer</label>
          <Comp_ProjectDeveloper
            ref={tagrefDeveloper}   
            defaultTags={selectedDevelopers}
            selectedTags={selectedDevelopers}
            setSelectedTags={(tags) =>
              handleDeveloperChange(tags)}    
            >

          </Comp_ProjectDeveloper>
        </div>
      </div>

      <div className="row third">
        <div className="item">
          <label>Project Name</label>
          <input
            type="text"
            name="project"
            value={query?.project || ""}
            onChange={handleChange}
            placeholder="Project Name"
          />
        </div>
      </div>



      <div className="row fourth">
        <div className="item">
          <label>Bedrooms</label>
          <input
            type="number"
            name="bedroom"
            value={query?.bedroom || ""}
            onChange={handleChange}
            placeholder="Beds"
          />
        </div>

        <div className="item">
          <label>Min Price</label>
          <input
            type="number"
            name="minprice"
            value={query?.minprice || ""}
            onChange={handleChange}
            placeholder="any"
          />
        </div>

        <div className="item">
          <label>Max Price</label>
          <input
            type="number"
            name="maxprice"
            value={query?.maxprice || ""}
            onChange={handleChange}
            placeholder="any"
          />
        </div>

      </div>
    
    <div className="row fifth">
        <div className="item">
          <label>Project Type</label>
          <ToggleSelect
            options={[
                { label: "Residential", value: "R" },
                { label: "Commercial", value: "C" }
              ]}
              defaultValue="R"
              allowDeselect={true}
              onChange={(val) => setQuery(prev => ({ ...prev, type: val }))}
              >


          </ToggleSelect>

        </div>


        <div className="item">
          <label>Min Area</label>
          <input
            type="number"
            name="minarea"
            value={query?.minarea || ""}
            onChange={handleChange}
            placeholder="any"
          />
        </div>

        <div className="item">
          <label>Max Area</label>
          <input
            type="number"
            name="maxarea"
            value={query?.maxarea || ""}
            onChange={handleChange}
            placeholder="any"
          />
        </div>





    </div>


      <div className="row sixth">
        {/* <div className="item srchButton"> */}
          <button onClick={handleFilter}>
            <img src={search} alt="search" />
          </button>
        {/* </div> */}

      </div>
    </div>
  );
});

export default ProjectFilter;
